module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/RewardItem/images/stubs/stub-default.7575e918.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/RewardItem/images/stubs/stub-default.png
// module id = 2945
// module chunks = 11